<template>
    <div>
        <v-tabs grow color="secondary" dark icons-and-text>
            <v-tabs-slider color="accent"></v-tabs-slider>
<!--            <v-tab href="#refund">-->
<!--                Refund-->
<!--                <v-icon color="white">money</v-icon>-->
<!--            </v-tab>-->
            <v-tab href="#penalties">
                Penalties
                <v-icon color="white">thumb_down_alt</v-icon>
            </v-tab>
            <v-tab href="#bonus">
                Bonus
                <v-icon color="white">fa fa-plus</v-icon>
            </v-tab>
<!--            <v-tab-item value="refund">-->
<!--                <refund/>-->
<!--            </v-tab-item>-->
            <v-tab-item value="penalties">
                <penalty/>
            </v-tab-item>
            <v-tab-item value="bonus">
                <bonus/>
            </v-tab-item>
        </v-tabs>
    </div>
</template>

<script>
    import LoadingComponent from "@/components/LoadingComponent";
    import Refund from "@/components/accounting/Refund";
    import Penalty from "@/components/accounting/Penalty";
    import Bonus from "@/components/accounting/Bonus";

    export default {
        name: "Transactions",
        title: 'Transactions',
        components: {Penalty, Refund, LoadingComponent,Bonus},
        data() {
            return {
                loading: false,
            }
        }
    }
</script>

<style scoped>

</style>